import { render, staticRenderFns } from "./FolioTable.vue?vue&type=template&id=0e4b82fa&scoped=true&"
import script from "./FolioTable.vue?vue&type=script&lang=js&"
export * from "./FolioTable.vue?vue&type=script&lang=js&"
import style0 from "./FolioTable.vue?vue&type=style&index=0&id=0e4b82fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b82fa",
  null
  
)

export default component.exports